// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { antiForgeryGet, authGetUser, authLogin, authLogout, babyPost, babyPut, calculatePut, camperPost, camperPut, carPost, carPut, catPost, catPut, checkoutGet, checkoutPut, childPost, childPut, configurationGet, contentGet, coreDataGetCarMakers, coreDataGetCarMakersAndModels, coreDataGetCarModelsByMaker, coreDataGetCatBreeds, coreDataGetCountries, coreDataGetDogBreeds, coreDataGetFinanceCompanies, coreDataGetMunicipalities, coreDataGetPostalCodes, coreDataGetSportTypes, coreDataGetVanMakers, coreDataGetVanMakersAndModels, coreDataGetVanModelsByMaker, coveragePut, coverageSetDeductibleAmount, coverageSetInsuranceAmount, customerContextGetContext, customerContextUpdateContext, dogPost, dogPut, householderPost, householderPut, incomePost, incomePut, offerGet, offerGetById, offerPut, type Options, policyHolderPut, quoteAddToCart, quoteCalculate, quoteDelete, sportPost, sportPut, travelPost, travelPut, vanPost, vanPut } from '../sdk.gen';
import type { AntiForgeryGetData, AntiForgeryGetResponse, AuthGetUserData, AuthGetUserResponse, AuthLoginData, AuthLoginResponse, AuthLogoutData, AuthLogoutResponse, BabyPostData, BabyPostResponse, BabyPutData, BabyPutResponse, CalculatePutData, CalculatePutResponse, CamperPostData, CamperPostResponse, CamperPutData, CamperPutResponse, CarPostData, CarPostResponse, CarPutData, CarPutResponse, CatPostData, CatPostResponse, CatPutData, CatPutResponse, CheckoutGetData, CheckoutGetResponse, CheckoutPutData, CheckoutPutResponse, ChildPostData, ChildPostResponse, ChildPutData, ChildPutResponse, ConfigurationGetData, ConfigurationGetResponse, ContentGetData, ContentGetResponse, CoreDataGetCarMakersAndModelsData, CoreDataGetCarMakersAndModelsResponse, CoreDataGetCarMakersData, CoreDataGetCarMakersResponse, CoreDataGetCarModelsByMakerData, CoreDataGetCarModelsByMakerResponse, CoreDataGetCatBreedsData, CoreDataGetCatBreedsResponse, CoreDataGetCountriesData, CoreDataGetCountriesResponse, CoreDataGetDogBreedsData, CoreDataGetDogBreedsResponse, CoreDataGetFinanceCompaniesData, CoreDataGetFinanceCompaniesResponse, CoreDataGetMunicipalitiesData, CoreDataGetMunicipalitiesResponse, CoreDataGetPostalCodesData, CoreDataGetPostalCodesResponse, CoreDataGetSportTypesData, CoreDataGetSportTypesResponse, CoreDataGetVanMakersAndModelsData, CoreDataGetVanMakersAndModelsResponse, CoreDataGetVanMakersData, CoreDataGetVanMakersResponse, CoreDataGetVanModelsByMakerData, CoreDataGetVanModelsByMakerResponse, CoveragePutData, CoveragePutResponse, CoverageSetDeductibleAmountData, CoverageSetDeductibleAmountResponse, CoverageSetInsuranceAmountData, CoverageSetInsuranceAmountResponse, CustomerContextGetContextData, CustomerContextGetContextResponse, CustomerContextUpdateContextData, CustomerContextUpdateContextResponse, DogPostData, DogPostResponse, DogPutData, DogPutResponse, HouseholderPostData, HouseholderPostResponse, HouseholderPutData, HouseholderPutResponse, IncomePostData, IncomePostResponse, IncomePutData, IncomePutResponse, OfferGetByIdData, OfferGetByIdResponse, OfferGetData, OfferGetResponse, OfferPutData, OfferPutResponse, PolicyHolderPutData, PolicyHolderPutResponse, QuoteAddToCartData, QuoteAddToCartResponse, QuoteCalculateData, QuoteCalculateResponse, QuoteDeleteData, QuoteDeleteResponse, SportPostData, SportPostResponse, SportPutData, SportPutResponse, TravelPostData, TravelPostResponse, TravelPutData, TravelPutResponse, VanPostData, VanPostResponse, VanPutData, VanPutResponse } from '../types.gen';

export const coveragePutMutation = (options?: Partial<Options<CoveragePutData>>): UseMutationOptions<CoveragePutResponse, DefaultError, Options<CoveragePutData>> => {
    const mutationOptions: UseMutationOptions<CoveragePutResponse, DefaultError, Options<CoveragePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await coveragePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const coverageSetInsuranceAmountMutation = (options?: Partial<Options<CoverageSetInsuranceAmountData>>): UseMutationOptions<CoverageSetInsuranceAmountResponse, DefaultError, Options<CoverageSetInsuranceAmountData>> => {
    const mutationOptions: UseMutationOptions<CoverageSetInsuranceAmountResponse, DefaultError, Options<CoverageSetInsuranceAmountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await coverageSetInsuranceAmount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const coverageSetDeductibleAmountMutation = (options?: Partial<Options<CoverageSetDeductibleAmountData>>): UseMutationOptions<CoverageSetDeductibleAmountResponse, DefaultError, Options<CoverageSetDeductibleAmountData>> => {
    const mutationOptions: UseMutationOptions<CoverageSetDeductibleAmountResponse, DefaultError, Options<CoverageSetDeductibleAmountData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await coverageSetDeductibleAmount({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const quoteDeleteMutation = (options?: Partial<Options<QuoteDeleteData>>): UseMutationOptions<QuoteDeleteResponse, DefaultError, Options<QuoteDeleteData>> => {
    const mutationOptions: UseMutationOptions<QuoteDeleteResponse, DefaultError, Options<QuoteDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await quoteDelete({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const quoteAddToCartMutation = (options?: Partial<Options<QuoteAddToCartData>>): UseMutationOptions<QuoteAddToCartResponse, DefaultError, Options<QuoteAddToCartData>> => {
    const mutationOptions: UseMutationOptions<QuoteAddToCartResponse, DefaultError, Options<QuoteAddToCartData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await quoteAddToCart({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const quoteCalculateMutation = (options?: Partial<Options<QuoteCalculateData>>): UseMutationOptions<QuoteCalculateResponse, DefaultError, Options<QuoteCalculateData>> => {
    const mutationOptions: UseMutationOptions<QuoteCalculateResponse, DefaultError, Options<QuoteCalculateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await quoteCalculate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const policyHolderPutMutation = (options?: Partial<Options<PolicyHolderPutData>>): UseMutationOptions<PolicyHolderPutResponse, DefaultError, Options<PolicyHolderPutData>> => {
    const mutationOptions: UseMutationOptions<PolicyHolderPutResponse, DefaultError, Options<PolicyHolderPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await policyHolderPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const calculatePutMutation = (options?: Partial<Options<CalculatePutData>>): UseMutationOptions<CalculatePutResponse, DefaultError, Options<CalculatePutData>> => {
    const mutationOptions: UseMutationOptions<CalculatePutResponse, DefaultError, Options<CalculatePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await calculatePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const checkoutGetQueryKey = (options?: Options<CheckoutGetData>) => createQueryKey('checkoutGet', options);

export const checkoutGetOptions = (options?: Options<CheckoutGetData>) => queryOptions<CheckoutGetResponse, DefaultError, CheckoutGetResponse, ReturnType<typeof checkoutGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkoutGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkoutGetQueryKey(options)
});

export const checkoutPutMutation = (options?: Partial<Options<CheckoutPutData>>): UseMutationOptions<CheckoutPutResponse, DefaultError, Options<CheckoutPutData>> => {
    const mutationOptions: UseMutationOptions<CheckoutPutResponse, DefaultError, Options<CheckoutPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await checkoutPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const offerGetQueryKey = (options?: Options<OfferGetData>) => createQueryKey('offerGet', options);

export const offerGetOptions = (options?: Options<OfferGetData>) => queryOptions<OfferGetResponse, DefaultError, OfferGetResponse, ReturnType<typeof offerGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await offerGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: offerGetQueryKey(options)
});

export const offerPutMutation = (options?: Partial<Options<OfferPutData>>): UseMutationOptions<OfferPutResponse, DefaultError, Options<OfferPutData>> => {
    const mutationOptions: UseMutationOptions<OfferPutResponse, DefaultError, Options<OfferPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await offerPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const offerGetByIdQueryKey = (options: Options<OfferGetByIdData>) => createQueryKey('offerGetById', options);

export const offerGetByIdOptions = (options: Options<OfferGetByIdData>) => queryOptions<OfferGetByIdResponse, DefaultError, OfferGetByIdResponse, ReturnType<typeof offerGetByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await offerGetById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: offerGetByIdQueryKey(options)
});

export const coreDataGetMunicipalitiesQueryKey = (options?: Options<CoreDataGetMunicipalitiesData>) => createQueryKey('coreDataGetMunicipalities', options);

export const coreDataGetMunicipalitiesOptions = (options?: Options<CoreDataGetMunicipalitiesData>) => queryOptions<CoreDataGetMunicipalitiesResponse, DefaultError, CoreDataGetMunicipalitiesResponse, ReturnType<typeof coreDataGetMunicipalitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetMunicipalities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetMunicipalitiesQueryKey(options)
});

export const coreDataGetCountriesQueryKey = (options?: Options<CoreDataGetCountriesData>) => createQueryKey('coreDataGetCountries', options);

export const coreDataGetCountriesOptions = (options?: Options<CoreDataGetCountriesData>) => queryOptions<CoreDataGetCountriesResponse, DefaultError, CoreDataGetCountriesResponse, ReturnType<typeof coreDataGetCountriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetCountries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetCountriesQueryKey(options)
});

export const coreDataGetPostalCodesQueryKey = (options?: Options<CoreDataGetPostalCodesData>) => createQueryKey('coreDataGetPostalCodes', options);

export const coreDataGetPostalCodesOptions = (options?: Options<CoreDataGetPostalCodesData>) => queryOptions<CoreDataGetPostalCodesResponse, DefaultError, CoreDataGetPostalCodesResponse, ReturnType<typeof coreDataGetPostalCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetPostalCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetPostalCodesQueryKey(options)
});

export const coreDataGetSportTypesQueryKey = (options?: Options<CoreDataGetSportTypesData>) => createQueryKey('coreDataGetSportTypes', options);

export const coreDataGetSportTypesOptions = (options?: Options<CoreDataGetSportTypesData>) => queryOptions<CoreDataGetSportTypesResponse, DefaultError, CoreDataGetSportTypesResponse, ReturnType<typeof coreDataGetSportTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetSportTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetSportTypesQueryKey(options)
});

export const coreDataGetCatBreedsQueryKey = (options?: Options<CoreDataGetCatBreedsData>) => createQueryKey('coreDataGetCatBreeds', options);

export const coreDataGetCatBreedsOptions = (options?: Options<CoreDataGetCatBreedsData>) => queryOptions<CoreDataGetCatBreedsResponse, DefaultError, CoreDataGetCatBreedsResponse, ReturnType<typeof coreDataGetCatBreedsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetCatBreeds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetCatBreedsQueryKey(options)
});

export const coreDataGetDogBreedsQueryKey = (options?: Options<CoreDataGetDogBreedsData>) => createQueryKey('coreDataGetDogBreeds', options);

export const coreDataGetDogBreedsOptions = (options?: Options<CoreDataGetDogBreedsData>) => queryOptions<CoreDataGetDogBreedsResponse, DefaultError, CoreDataGetDogBreedsResponse, ReturnType<typeof coreDataGetDogBreedsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetDogBreeds({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetDogBreedsQueryKey(options)
});

export const coreDataGetFinanceCompaniesQueryKey = (options?: Options<CoreDataGetFinanceCompaniesData>) => createQueryKey('coreDataGetFinanceCompanies', options);

export const coreDataGetFinanceCompaniesOptions = (options?: Options<CoreDataGetFinanceCompaniesData>) => queryOptions<CoreDataGetFinanceCompaniesResponse, DefaultError, CoreDataGetFinanceCompaniesResponse, ReturnType<typeof coreDataGetFinanceCompaniesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetFinanceCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetFinanceCompaniesQueryKey(options)
});

export const coreDataGetVanMakersQueryKey = (options?: Options<CoreDataGetVanMakersData>) => createQueryKey('coreDataGetVanMakers', options);

export const coreDataGetVanMakersOptions = (options?: Options<CoreDataGetVanMakersData>) => queryOptions<CoreDataGetVanMakersResponse, DefaultError, CoreDataGetVanMakersResponse, ReturnType<typeof coreDataGetVanMakersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetVanMakers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetVanMakersQueryKey(options)
});

export const coreDataGetVanMakersAndModelsQueryKey = (options?: Options<CoreDataGetVanMakersAndModelsData>) => createQueryKey('coreDataGetVanMakersAndModels', options);

export const coreDataGetVanMakersAndModelsOptions = (options?: Options<CoreDataGetVanMakersAndModelsData>) => queryOptions<CoreDataGetVanMakersAndModelsResponse, DefaultError, CoreDataGetVanMakersAndModelsResponse, ReturnType<typeof coreDataGetVanMakersAndModelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetVanMakersAndModels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetVanMakersAndModelsQueryKey(options)
});

export const coreDataGetVanModelsByMakerQueryKey = (options?: Options<CoreDataGetVanModelsByMakerData>) => createQueryKey('coreDataGetVanModelsByMaker', options);

export const coreDataGetVanModelsByMakerOptions = (options?: Options<CoreDataGetVanModelsByMakerData>) => queryOptions<CoreDataGetVanModelsByMakerResponse, DefaultError, CoreDataGetVanModelsByMakerResponse, ReturnType<typeof coreDataGetVanModelsByMakerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetVanModelsByMaker({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetVanModelsByMakerQueryKey(options)
});

export const coreDataGetCarMakersQueryKey = (options?: Options<CoreDataGetCarMakersData>) => createQueryKey('coreDataGetCarMakers', options);

export const coreDataGetCarMakersOptions = (options?: Options<CoreDataGetCarMakersData>) => queryOptions<CoreDataGetCarMakersResponse, DefaultError, CoreDataGetCarMakersResponse, ReturnType<typeof coreDataGetCarMakersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetCarMakers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetCarMakersQueryKey(options)
});

export const coreDataGetCarMakersAndModelsQueryKey = (options?: Options<CoreDataGetCarMakersAndModelsData>) => createQueryKey('coreDataGetCarMakersAndModels', options);

export const coreDataGetCarMakersAndModelsOptions = (options?: Options<CoreDataGetCarMakersAndModelsData>) => queryOptions<CoreDataGetCarMakersAndModelsResponse, DefaultError, CoreDataGetCarMakersAndModelsResponse, ReturnType<typeof coreDataGetCarMakersAndModelsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetCarMakersAndModels({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetCarMakersAndModelsQueryKey(options)
});

export const coreDataGetCarModelsByMakerQueryKey = (options?: Options<CoreDataGetCarModelsByMakerData>) => createQueryKey('coreDataGetCarModelsByMaker', options);

export const coreDataGetCarModelsByMakerOptions = (options?: Options<CoreDataGetCarModelsByMakerData>) => queryOptions<CoreDataGetCarModelsByMakerResponse, DefaultError, CoreDataGetCarModelsByMakerResponse, ReturnType<typeof coreDataGetCarModelsByMakerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await coreDataGetCarModelsByMaker({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: coreDataGetCarModelsByMakerQueryKey(options)
});

export const contentGetQueryKey = (options: Options<ContentGetData>) => createQueryKey('contentGet', options);

export const contentGetOptions = (options: Options<ContentGetData>) => queryOptions<ContentGetResponse, DefaultError, ContentGetResponse, ReturnType<typeof contentGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await contentGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: contentGetQueryKey(options)
});

export const vanPostMutation = (options?: Partial<Options<VanPostData>>): UseMutationOptions<VanPostResponse, DefaultError, Options<VanPostData>> => {
    const mutationOptions: UseMutationOptions<VanPostResponse, DefaultError, Options<VanPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vanPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const vanPutMutation = (options?: Partial<Options<VanPutData>>): UseMutationOptions<VanPutResponse, DefaultError, Options<VanPutData>> => {
    const mutationOptions: UseMutationOptions<VanPutResponse, DefaultError, Options<VanPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await vanPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const travelPostMutation = (options?: Partial<Options<TravelPostData>>): UseMutationOptions<TravelPostResponse, DefaultError, Options<TravelPostData>> => {
    const mutationOptions: UseMutationOptions<TravelPostResponse, DefaultError, Options<TravelPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await travelPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const travelPutMutation = (options?: Partial<Options<TravelPutData>>): UseMutationOptions<TravelPutResponse, DefaultError, Options<TravelPutData>> => {
    const mutationOptions: UseMutationOptions<TravelPutResponse, DefaultError, Options<TravelPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await travelPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sportPostMutation = (options?: Partial<Options<SportPostData>>): UseMutationOptions<SportPostResponse, DefaultError, Options<SportPostData>> => {
    const mutationOptions: UseMutationOptions<SportPostResponse, DefaultError, Options<SportPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sportPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const sportPutMutation = (options?: Partial<Options<SportPutData>>): UseMutationOptions<SportPutResponse, DefaultError, Options<SportPutData>> => {
    const mutationOptions: UseMutationOptions<SportPutResponse, DefaultError, Options<SportPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sportPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const incomePostMutation = (options?: Partial<Options<IncomePostData>>): UseMutationOptions<IncomePostResponse, DefaultError, Options<IncomePostData>> => {
    const mutationOptions: UseMutationOptions<IncomePostResponse, DefaultError, Options<IncomePostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await incomePost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const incomePutMutation = (options?: Partial<Options<IncomePutData>>): UseMutationOptions<IncomePutResponse, DefaultError, Options<IncomePutData>> => {
    const mutationOptions: UseMutationOptions<IncomePutResponse, DefaultError, Options<IncomePutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await incomePut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const householderPostMutation = (options?: Partial<Options<HouseholderPostData>>): UseMutationOptions<HouseholderPostResponse, DefaultError, Options<HouseholderPostData>> => {
    const mutationOptions: UseMutationOptions<HouseholderPostResponse, DefaultError, Options<HouseholderPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await householderPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const householderPutMutation = (options?: Partial<Options<HouseholderPutData>>): UseMutationOptions<HouseholderPutResponse, DefaultError, Options<HouseholderPutData>> => {
    const mutationOptions: UseMutationOptions<HouseholderPutResponse, DefaultError, Options<HouseholderPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await householderPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dogPostMutation = (options?: Partial<Options<DogPostData>>): UseMutationOptions<DogPostResponse, DefaultError, Options<DogPostData>> => {
    const mutationOptions: UseMutationOptions<DogPostResponse, DefaultError, Options<DogPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dogPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const dogPutMutation = (options?: Partial<Options<DogPutData>>): UseMutationOptions<DogPutResponse, DefaultError, Options<DogPutData>> => {
    const mutationOptions: UseMutationOptions<DogPutResponse, DefaultError, Options<DogPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await dogPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const childPostMutation = (options?: Partial<Options<ChildPostData>>): UseMutationOptions<ChildPostResponse, DefaultError, Options<ChildPostData>> => {
    const mutationOptions: UseMutationOptions<ChildPostResponse, DefaultError, Options<ChildPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await childPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const childPutMutation = (options?: Partial<Options<ChildPutData>>): UseMutationOptions<ChildPutResponse, DefaultError, Options<ChildPutData>> => {
    const mutationOptions: UseMutationOptions<ChildPutResponse, DefaultError, Options<ChildPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await childPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const catPostMutation = (options?: Partial<Options<CatPostData>>): UseMutationOptions<CatPostResponse, DefaultError, Options<CatPostData>> => {
    const mutationOptions: UseMutationOptions<CatPostResponse, DefaultError, Options<CatPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await catPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const catPutMutation = (options?: Partial<Options<CatPutData>>): UseMutationOptions<CatPutResponse, DefaultError, Options<CatPutData>> => {
    const mutationOptions: UseMutationOptions<CatPutResponse, DefaultError, Options<CatPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await catPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const carPostMutation = (options?: Partial<Options<CarPostData>>): UseMutationOptions<CarPostResponse, DefaultError, Options<CarPostData>> => {
    const mutationOptions: UseMutationOptions<CarPostResponse, DefaultError, Options<CarPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await carPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const carPutMutation = (options?: Partial<Options<CarPutData>>): UseMutationOptions<CarPutResponse, DefaultError, Options<CarPutData>> => {
    const mutationOptions: UseMutationOptions<CarPutResponse, DefaultError, Options<CarPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await carPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const camperPostMutation = (options?: Partial<Options<CamperPostData>>): UseMutationOptions<CamperPostResponse, DefaultError, Options<CamperPostData>> => {
    const mutationOptions: UseMutationOptions<CamperPostResponse, DefaultError, Options<CamperPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await camperPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const camperPutMutation = (options?: Partial<Options<CamperPutData>>): UseMutationOptions<CamperPutResponse, DefaultError, Options<CamperPutData>> => {
    const mutationOptions: UseMutationOptions<CamperPutResponse, DefaultError, Options<CamperPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await camperPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const babyPostMutation = (options?: Partial<Options<BabyPostData>>): UseMutationOptions<BabyPostResponse, DefaultError, Options<BabyPostData>> => {
    const mutationOptions: UseMutationOptions<BabyPostResponse, DefaultError, Options<BabyPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await babyPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const babyPutMutation = (options?: Partial<Options<BabyPutData>>): UseMutationOptions<BabyPutResponse, DefaultError, Options<BabyPutData>> => {
    const mutationOptions: UseMutationOptions<BabyPutResponse, DefaultError, Options<BabyPutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await babyPut({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const antiForgeryGetQueryKey = (options?: Options<AntiForgeryGetData>) => createQueryKey('antiForgeryGet', options);

export const antiForgeryGetOptions = (options?: Options<AntiForgeryGetData>) => queryOptions<AntiForgeryGetResponse, DefaultError, AntiForgeryGetResponse, ReturnType<typeof antiForgeryGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await antiForgeryGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: antiForgeryGetQueryKey(options)
});

export const configurationGetQueryKey = (options?: Options<ConfigurationGetData>) => createQueryKey('configurationGet', options);

export const configurationGetOptions = (options?: Options<ConfigurationGetData>) => queryOptions<ConfigurationGetResponse, DefaultError, ConfigurationGetResponse, ReturnType<typeof configurationGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await configurationGet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: configurationGetQueryKey(options)
});

export const customerContextGetContextQueryKey = (options?: Options<CustomerContextGetContextData>) => createQueryKey('customerContextGetContext', options);

export const customerContextGetContextOptions = (options?: Options<CustomerContextGetContextData>) => queryOptions<CustomerContextGetContextResponse, DefaultError, CustomerContextGetContextResponse, ReturnType<typeof customerContextGetContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await customerContextGetContext({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: customerContextGetContextQueryKey(options)
});

export const customerContextUpdateContextMutation = (options?: Partial<Options<CustomerContextUpdateContextData>>): UseMutationOptions<CustomerContextUpdateContextResponse, DefaultError, Options<CustomerContextUpdateContextData>> => {
    const mutationOptions: UseMutationOptions<CustomerContextUpdateContextResponse, DefaultError, Options<CustomerContextUpdateContextData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await customerContextUpdateContext({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const authLoginQueryKey = (options?: Options<AuthLoginData>) => createQueryKey('authLogin', options);

export const authLoginOptions = (options?: Options<AuthLoginData>) => queryOptions<AuthLoginResponse, DefaultError, AuthLoginResponse, ReturnType<typeof authLoginQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authLogin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authLoginQueryKey(options)
});

export const authGetUserQueryKey = (options?: Options<AuthGetUserData>) => createQueryKey('authGetUser', options);

export const authGetUserOptions = (options?: Options<AuthGetUserData>) => queryOptions<AuthGetUserResponse, DefaultError, AuthGetUserResponse, ReturnType<typeof authGetUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authGetUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authGetUserQueryKey(options)
});

export const authLogoutQueryKey = (options?: Options<AuthLogoutData>) => createQueryKey('authLogout', options);

export const authLogoutOptions = (options?: Options<AuthLogoutData>) => queryOptions<AuthLogoutResponse, DefaultError, AuthLogoutResponse, ReturnType<typeof authLogoutQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await authLogout({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: authLogoutQueryKey(options)
});
